export enum HttpStatusCode {
	Unauthorized = 401,
}
